export class ProductPackStyleReq{
    productId:number
    packStyleId:number

    constructor( productId:number,packStyleId:number){
        this.productId = productId
        this.packStyleId = packStyleId
    }
}